import { gql } from '@apollo/client';
import {
  EvaluationRequestFields,
  InvoiceIdFields,
  PreofferFields,
} from '../invoices/fragments';

const REQUEST_CREDIT_LINE_SUBLINE_AND_PRE_OFFER_EVALUATION = gql`
  mutation requestCreditLineSublineAndPreOfferEvaluation(
    $invoiceIds: [ID]!
    $debtorRuts: [String]
  ) {
    requestCreditLineSublineAndPreOfferEvaluation(
      invoiceIds: $invoiceIds
      debtorRuts: $debtorRuts
    ) {
      invoicesEvaluated {
        ...InvoiceIdFields
        preoffer {
          ...PreofferFields
          preofferevaluationrequest {
            ...EvaluationRequestFields
          }
        }
      }
      warningCode
    }
  }
  ${InvoiceIdFields}
  ${PreofferFields}
  ${EvaluationRequestFields}
`;

export default REQUEST_CREDIT_LINE_SUBLINE_AND_PRE_OFFER_EVALUATION;
